/**
 * Factory for creating CreateServiceOrder requests.
 */
import {ICase, IUser} from '@service-and-repairs/awpintegrationlib';
import {AwpDmsInterfaceFactoryUtils} from '../../rest-api/awp-dms-interface-factory-utils';
import {
  CreateServiceOrderRequest,
  CreateServiceOrderRequestBody,
  OrderCustomerInformation,
  OrderVehicleInformation,
  ServiceOrder,
  ServiceOrderJob,
  ServiceOrderMileage,
  VehicleBrand
} from '../order';

export class AwpDmsInterfaceCreateServiceOrderRequestFactory {

  createRequest(user: IUser, serviceCase: ICase): CreateServiceOrderRequest {
    const req = new CreateServiceOrderRequest();
    req.functionalHeader = AwpDmsInterfaceFactoryUtils.createFunctionalHeader(serviceCase);
    req.technicalHeader = AwpDmsInterfaceFactoryUtils.createTechnicalHeaderInRequest(
      'awp-dms-create-service-order-request',
      '1.1.0'
    );
    req.userInformation = AwpDmsInterfaceFactoryUtils.createUserInformation(user);
    req.body = this.createRequestBody(serviceCase);
    return req;
  }

  createRequestBody(serviceCase: ICase): CreateServiceOrderRequestBody {
    const body = new CreateServiceOrderRequestBody();
    body.customerInformation = this.createCustomerInformation(serviceCase);
    body.serviceOrder = this.createServiceOrder(serviceCase);
    body.vehicleInformation = this.createVehicleInformation(serviceCase);
    return body;
  }

  createCustomerInformation(serviceCase: ICase): OrderCustomerInformation {
    const customer = new OrderCustomerInformation();
    customer.dmsCustomerId = serviceCase.getDmsCustomerNumber()?.trim() || undefined;
    return customer;
  }

  createServiceOrder(serviceCase: ICase): ServiceOrder {
    const order = new ServiceOrder();
    order.bmwServiceCaseId = serviceCase.getExternalId();
    order.mileage = this.createMileage(serviceCase);
    order.jobList = this.createJobList(serviceCase);
    return order;
  }

  createMileage(serviceCase: ICase): ServiceOrderMileage | undefined {
    const mileageValue: number = serviceCase.getCurrentMileageInKilometers();
    if (mileageValue == null) {
      return undefined;
    }
    const mileage = new ServiceOrderMileage();
    mileage.unit = 'km';
    mileage.value = mileageValue;
    return mileage;
  }

  createJobList(serviceCase: ICase): ServiceOrderJob[] {
    const currencyCode = serviceCase.getCurrencyCode();
    return serviceCase.getJobs().map(job => AwpDmsInterfaceFactoryUtils.createServiceOrderJob(job, currencyCode));
  }

  createVehicleInformation(serviceCase: ICase): OrderVehicleInformation {
    const vehicle = new OrderVehicleInformation();
    vehicle.vin = serviceCase.getVinLong();
    vehicle.brand = AwpDmsInterfaceFactoryUtils.createBrandString(serviceCase.getBrand()) as VehicleBrand;
    vehicle.numberPlate = serviceCase.getLicensePlate() || undefined;
    return vehicle;
  }
}
